import React from 'react';
import PropTypes from 'prop-types';

export const ChartLegendValue = ({ children }) => {
    return (
        <div
            className="helix-legend-value mt-2">
            {children}
        </div>
    );
};

ChartLegendValue.propTypes = {
    children: PropTypes.string
};
